import { colors, fonts, screen } from 'components/styles/variables';
import css from 'styled-jsx/css';

export const headerCss = css`
  header {
    display: flex;
    flex-direction: column;
  }

  .dealer-name {
    font-family: ${fonts.default};
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    color: ${colors.BLACK};
    margin: 0;
  }

  @media screen and (min-width: ${screen.smMin}) {
    .dealer-name {
      font-size: 20px;
    }
  }
`;
